<template>
  <div class="flex min-h-full flex-1 flex-col justify-center pt-24 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <img class="mx-auto" src="/assets/images/Knocknoc_long_darkbg_Large_redish.png" alt="Knocknoc logo" />
    </div>

    <div class="mt-6 flex flex-col gap-6 sm:mx-auto sm:w-full sm:max-w-sm">
      <span class="text-center text-xl font-semibold tracking-tight">{{ t("msg.twoFactorAuth") }}</span>

      <FormKit
        type="form"
        :actions="false"
        @submit="handleLogin"
        @submit-invalid="globals.focusFirstError"
        :errors="[errorMessage].filter(Boolean)"
      >
        <FormKit
          type="text"
          :classes="{
            outer: '!max-w-full',
          }"
          :label="t('msg.code')"
          name="Code"
          validation="required"
          autocomplete="off"
        />

        <FormKit
          type="submit"
          :classes="{
            outer: '$reset',
            input:
              '$reset inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:h-4 [&_svg]:w-4 [&_svg]:shrink-0 bg-primary text-primary-foreground shadow hover:bg-primary/90 h-9 px-4 py-2',
          }"
          :disabled="isSubmitting || disabled"
        >
          <font-awesome-icon v-if="isSubmitting" icon="fa-sharp-duotone fa-solid fa-spinner-third" spin />
          {{ t("msg.login") }}
        </FormKit>
      </FormKit>

      <button
        @click="logout"
        class="inline-flex h-10 items-center justify-center gap-2 whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium text-primary underline-offset-4 ring-offset-background transition-colors hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0"
      >
        {{ t("msg.backToLogin") }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import authService from "../../services/auth.service.ts";
import { useI18n } from "vue-i18n";
import { useAdminStore } from "../../pinia/admin.ts";
import globals from "../../globals";

const { t } = useI18n();

const adminStore = useAdminStore();

const router = useRouter();

const errorMessage = ref("");

const isSubmitting = ref(false);

async function handleLogin(fields) {
  isSubmitting.value = true;

  try {
    await authService.adminTwoFactorVerify(JSON.stringify(fields));
    await adminStore.fetchStatus({ force: true });

    router.push({ name: "AdminHome" });
  } catch (error) {
    errorMessage.value = globals.renderError(t, error);
  } finally {
    isSubmitting.value = false;
  }
}

const logout = async () => {
  await adminStore.logout();
  router.push({ name: "AdminLogin" });
};
</script>
